module.exports = __webpack_public_path__ + "static/360-icon-b51fa3a510b0ccd5019ee842ab974c5b.png";